// extracted by mini-css-extract-plugin
export var label = "_a9-1";
export var reminder = "_a9-0";